<template lang="pug">
  v-row(justify="center")
    v-dialog(v-model="dialog" max-width="400px")
      template(v-slot:activator="{ on, attrs }")
        .follow-button
          v-btn(v-bind="attrs" v-on="on" tile :min-width="260" )
            v-icon(left small) mdi-bell
            | この居場所をフォロー
      v-card
        v-card-title(class="justify-center")
          span(class="text-h6") フォローにはログインが必要です
        v-card-text
          slot
          v-row(class="mt-3 justify-center")
            v-btn(small text @click="dialog = false") 閉じる
</template>

<script type="module">

export default {
  data: function () {
    return {
      dialog: false
    }
  },
  methods: {
    open () {
      this.isOpen = true;
    }
  }
}
</script>

<style scoped>
.follow-button {
  margin-top: 20px;
}
</style>

